module.exports = __webpack_public_path__ + "static/media/quindio-47.0d0edb9a.jpg";